$('document').ready(() => {
    const sliders = document.querySelectorAll('.category-slider');

    sliders.forEach(slider => {
        const navCountShowed = document.querySelector('[data-nav-count-showed]');
        const navCountAll = document.querySelector('[data-nav-count-all]');
        const settingsSlider = {
            slidesPerView: 2,
            spaceBetween: 8,
            grabCursor: true,
            navigation: {
                nextEl: '.category-slider__nav--next',
                prevEl: '.category-slider__nav--prev',
            },
            watchSlidesProgress: true,
            breakpoints: {
                768: {
                    slidesPerView: 4,
                    spaceBetween: 12
                },

                1024: {
                    slidesPerView: 6,
                    spaceBetween: 24
                }
            },
            on: {
                init: function () {
                    console.log('swiper initialized');
                    navCountShowed.innerHTML = document.querySelectorAll('.swiper-slide-visible').length + this.activeIndex;
                    navCountAll.innerHTML = this.slides.length;
                },
                slideChange: function () {
                    navCountShowed.innerHTML = document.querySelectorAll('.swiper-slide-visible').length + this.activeIndex;
                },
                resize: function () {
                    console.log('swiper resize');
                    navCountShowed.innerHTML = document.querySelectorAll('.swiper-slide-visible').length + this.activeIndex;
                }
            },
        }

        let config = new Swiper(slider, settingsSlider)
    })
})
